<template>
  <div
    :class="[
      {
        'is-focus': isFocus
      }
    ]"
    class="d-flex flex-column w-100 p-3 wrapper-package"
  >
    <div class="text-center">
      <strong
        style="font-size: 24px;"
      >
        <i
          :class="appIcon"
          :style="`color: ${appColor};`"/>
        {{ title }}
      </strong>
    </div>
    <div
      v-if="isShowInfo"
      class="d-flex flex-column">
      <div>
        <BaseTable
          :hidePagination="true"
          class="custom-table"
          tableClass="table-bordered"
        >
          <template #thead>
            <thead>
              <tr>
                <th style="width: 50%;">{{ $t('apps.billing.message.application') }}</th>
                <th>{{ $t('apps.billing.message.module') }}</th>
              </tr>
            </thead>
          </template>
          <template #tbody>
            <tbody>
              <tr
                v-for="(module, index) in flattenedModules"
                :key="module.uniqueKey">
                <td
                  v-if="module.isFirst"
                  :rowspan="module.rowspan">
                  {{ module.appName }}
                </td>
                <td>{{ module.moduleName }}</td>
              </tr>
            </tbody>
          </template>
        </BaseTable>
        <BaseTable
          v-if="addOnTableRows.length"
          :hidePagination="true"
          class="custom-table mt-3"
          tableClass="table-bordered"
        >
          <template #thead>
            <thead>
              <tr>
                <th style="width: 50%;">{{ $t('apps.billing.label.addon') }}</th>
                <th>{{ $t('apps.billing.label.detail') }}</th>
              </tr>
            </thead>
          </template>
          <template #tbody>
            <tbody>
              <tr
                v-for="(item, index) in addOnTableRows"
                :key="index"
              >
                <td>
                  {{ item.item }}
                </td>
                <td>
                  {{ item.detail }}
                </td>
              </tr>
            </tbody>
          </template>
        </BaseTable>
        <BaseTable
          v-if="advancedTableRows.length"
          :hidePagination="true"
          class="custom-table mt-3"
          tableClass="table-bordered"
        >
          <template #thead>
            <thead>
              <tr>
                <th style="width: 50%;">{{ $t('apps.billing.label.advanced') }}</th>
                <th>{{ $t('apps.billing.label.detail') }}</th>
              </tr>
            </thead>
          </template>
          <template #tbody>
            <tbody>
              <tr
                v-for="(item, index) in advancedTableRows"
                :key="index"
              >
                <td>
                  {{ item.item }}
                </td>
                <td>
                  {{ item.detail }}
                </td>
              </tr>
            </tbody>
          </template>
        </BaseTable>
        <!-- <BaseTable
          v-if="channelTableRows.length"
          :hidePagination="true"
          class="custom-table mt-3"
          tableClass="table-bordered"
        >
          <template #thead>
            <thead>
              <tr>
                <th style="width: 50%;">{{ $t('apps.billing.label.channels') }}</th>
                <th>{{ $t('apps.billing.label.detail') }}</th>
              </tr>
            </thead>
          </template>
          <template #tbody>
            <tbody>
              <tr
                v-for="(item, index) in channelTableRows"
                :key="index"
              >
                <td>
                  {{ item.item }}
                </td>
                <td>
                  {{ item.detail }}
                </td>
              </tr>
            </tbody>
          </template>
        </BaseTable> -->
      </div>
    </div>
    <div class="price-list">
      <div
        v-for="(priceListItem, index) in priceList"
        :key="index"
        class="price-list-item"
      >
        <div class="switch">
          <vs-switch
            v-model="priceListItem.is_active"
            style="float: left;margin: 0 10px 0 0"
            color="#A3CA76"
            @change="handleChangeSwitch(index)"
          />
          <div class="text d-flex">
            <div>
              {{ priceListItem.label }}
              <span v-if="priceListItem.is_recommend">
                ({{ $t('apps.billing.message.bestsale') }})
              </span>
            </div>
            <span
              v-if="priceListItem.discount_amount > 0 && priceListItem.is_active"
              class="badge badge-danger ml-2"
              style="height: 18px;position: relative;top: 2px;"
            >
              <i class="fas fa-tag"/> {{ priceListItem.discount_percent }}%
              -{{ numeral(priceListItem.discount_amount).format('0,0.[00]') }}
            </span>
          </div>
        </div>
        <div class="price">
          <div
            v-if="priceListItem.is_active"
            class="d-flex"
            style="gap: 10px;"
          >
            <span
              v-if="priceListItem.discount_percent > 0"
              style="text-decoration: line-through;">
              {{ numeral(priceListItem.sub_total).format('0,0.[00]') }}
            </span>
            <span>
              +{{ numeral(priceListItem.total).format('0,0.[00]') }} THB
            </span>
          </div>
        </div>
      </div>
    </div>
    <div
      class="text-right d-flex justify-content-between align-items-center"
      style="border-top: solid #d8e2e7 1px;padding-top: 15px;gap: 5px;">
      <a
        href="https://treesoft.io/th/pricing"
        target="_blank">
        {{ $t('message.price') }}
        <i class="fas fa-external-link-alt"/>
      </a>
      <div>
        <BaseButton
          v-if="isShowBackHomeButton"
          :disabled="isSubmitted"
          className="btn-lg btn-light"
          style="font-size: 16px;"
          @click="handleClickClose"
        >
          {{ $t('button.close') }}
        </BaseButton>
        <BaseButton
          :disabled="isSubmitted"
          :class="[
            payButtonClass
          ]"
          className="btn-lg"
          style="font-size: 16px;"
          @click="handleClickPayButton"
        >
          <span v-if="isSubmitted"><i class="fas fa-spinner spin"/></span>
          <span v-else>
            {{ payButtonText }}
            <i class="fas fa-cloud-upload-alt"/>
          </span>
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<script>
import numeral from 'numeral'
import { getDiscountAmount, getTotalPrice } from '../../helpers'

export default {
  props: {
    title: String,
    packageKey: String,
    appIcon: String,
    appColor: String,
    masterPriceList: Array,
    apps: Array,
    isFocus: Boolean,
    isShowInfo: Boolean,
    isShowBackHomeButton: Boolean,
    advancedTableRows: Array,
    addOnTableRows: Array,
    channelTableRows: Array,
    payButtonText: String,
    payButtonClass: String,
  },

  data() {
    return {
      numeral,
      priceList: [],
      isSubmitted: false,
    }
  },

  computed: {
    total() {
      const priceListItem = this.priceList.find((item) => item.is_active)
      return priceListItem.total
    },
    monthNumber() {
      const priceListItem = this.priceList.find((item) => item.is_active)
      return priceListItem.month_number
    },
    flattenedModules() {
      return this.apps.flatMap(app =>
        app.modules.map((module, index) => ({
          uniqueKey: `${app.appId}-${module.moduleId}`,
          appName: app.appName,
          moduleName: module.moduleName,
          rowspan: app.modules.length,
          isFirst: index === 0,
        }))
      )
    },
  },

  methods: {
    handleChangeSwitch(index) {
      this.priceList = this.priceList.map((item, itemIndex) => {
        return {
          ...item,
          is_active: itemIndex == index,
        }
      })
    },
    handleClickPayButton() {
      this.isSubmitted = true

      setTimeout(() => {
        const detail = (() => {
          const isOneTimePurchase = this.monthNumber === 0
          if (isOneTimePurchase) {
            return this.$t(`apps.billing.packages.onetime.${this.packageKey}`)
          } else {
            return this.$t(`apps.billing.packages.detail.${this.packageKey}`, { month: this.monthNumber })
          }
        })()
        this.$emit('onSubmit', {
          packageKey: this.packageKey,
          monthNumber: this.monthNumber,
          total: this.total,
          detail: detail,
        })
      }, 1000)
    },
    handleClickClose() {
      this.$router.push({
        name: 'Home',
      })
    },
  },

  created() {
    this.priceList = this.masterPriceList
      .filter((item) => item.is_enabled)
      .map((item) => {
        const isOneTimePurchase = item.month_number === 0
        const currencyRateThb = 38
        const unitPrice = item.unit_price * currencyRateThb
        const subTotal = unitPrice
        const total = getTotalPrice(subTotal, item.discount_percent)('thb')
        const label = (() => {
          if (isOneTimePurchase) {
            return this.$t('apps.billing.message.onetimepurchase')
          } else {
            return this.$t('apps.billing.message.packagemonth', { month: item.month_number })
          }
        })()
        return {
          month_number: item.month_number,
          unit_price: unitPrice,
          discount_percent: item.discount_percent,
          sub_total: subTotal,
          total: total,
          discount_amount: getDiscountAmount(subTotal, item.discount_percent)('thb'),
          is_active: item.is_recommend == true,
          is_recommend: item.is_recommend,
          label: label,
        }
      })
  },
}
</script>

<style scoped>
.wrapper-package {
  background: #fff;
  border: solid #d8e2e7 1px;
  border-radius: 8px;
  gap: 10px;
}

.wrapper-package,
.wrapper-package th {
  font-size: 16px;
}

.wrapper-package.is-focus {
  background: #fffbee;
}

.price-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.price-list-item {
  display: flex;
  justify-content: space-between;
}
.price-list-item .switch {
  flex: 1;
}
.price-list-item .switch .text {
  position: relative;
  top: 1px;
}
.price-list-item .summary {
  text-align: right;
}
.price-list-item .price {
  text-align: right;
}

.custom-table >>> td:hover,
.custom-table >>> tr:hover {
  background: transparent;
}

.custom-table >>> thead,
.custom-table >>> tbody {
  background: transparent;
}

.custom-table >>> table.table-bordered.dataTable th:last-child,
.custom-table >>> table.table-bordered.dataTable th:last-child,
.custom-table >>> table.table-bordered.dataTable td:last-child,
.custom-table >>> table.table-bordered.dataTable td:last-child {
  border-right-width: thin !important;
}
</style>



// WEBPACK FOOTER //
// src/components/custom/Package.vue